import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=761d03c6"
import script from "./UserNew.vue?vue&type=script&lang=js"
export * from "./UserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports